"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutgoingReferral_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var OutgoingReferral_Factory = /** @class */ (function () {
    function OutgoingReferral_Factory() {
    }
    OutgoingReferral_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CloseDate: Date_Factory_1.Date_Factory.CreateIncoming(model.CloseDate),
            DueDateBack: Date_Factory_1.Date_Factory.CreateIncoming(model.DueDateBack),
            NoteId: model.NoteId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ReferralId: model.ReferralId,
        };
        return result;
    };
    OutgoingReferral_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CloseDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.CloseDate),
            DueDateBack: Date_Factory_1.Date_Factory.CreateOutgoing(model.DueDateBack),
            NoteId: model.NoteId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            ReferralId: model.ReferralId,
        };
        return result;
    };
    return OutgoingReferral_Factory;
}());
exports.OutgoingReferral_Factory = OutgoingReferral_Factory;
